import axios from "axios";

// API base URL
const baseURL = process.env.REACT_APP_API_URL;

// Image base URLs
export const IMAGE_BASE_URL = process.env.REACT_APP_BASE_URL;
export const DRIVER_IMAGE_URL = process.env.REACT_APP_DRIVER_IMAGE_URL;
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;

if (!baseURL || !DRIVER_IMAGE_URL || !GOOGLE_MAPS_KEY) {
  console.error("CRITICAL ERROR: Environment variables are not defined.");
}

const api = axios.create({
  baseURL,
});

export default api;
